import { Button, Stack, Typography } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import { useNavigate } from "react-router-dom";

export default function NoResultsTable({
  message,
  message2,
  buttonText,
  buttonLink,
  onClickButton,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClickButton) {
      onClickButton();
    } else {
      navigate(buttonLink);
    }
  };

  return (
    <Stack spacing={2.5} alignItems="center" sx={{ pt: "50px", pb: "50px" }}>
      <SearchOffOutlinedIcon
        sx={{
          color: "#00000061",
          height: "48px",
          width: "48px",
        }}
      />
      <Typography
        sx={{
          color: "#000000DE",
          fontSize: "24px",
          fontWeight: 600,
          fontFamily: "Roboto",
          textAlign: "center",
        }}
      >
        {message}
      </Typography>
      <Typography
        sx={{
          color: "#00000099",
          fontSize: "16px",
          fontWeight: 400,
          fontFamily: "Roboto",
          textAlign: "center",
        }}
      >
        {message2}
      </Typography>
      <Button
        sx={{
          backgroundColor: "#002878",
          color: "#fff",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "24px",
          letterSpacing: "0.15px",
          width: "fit-content",
          textTransform: "uppercase",
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: "#002878",
            color: "#fff",
          },
        }}
        variant="contained"
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </Stack>
  );
}
